export const ENVIRONMENT_RIBBON_CONFIG = {
  productionTesting: {
    text: '!! READONLY PRODUCTION DATA !!'
  },
  superUser: {
    text: 'Super User'
  },
  staging: {
    text: 'staging'
  },
  testing: {
    text: 'testing'
  },
  beta: {
    text: 'beta'
  }
}
